export const server = "https://sih-hackathon.onrender.com/api/v1";
// export const server = "http://localhost:8000/api/v1";

export const backend_API_endpoint = "https://sih-hackathon.onrender.com/";
// export const backend_API_endpoint = "http://localhost:8000/";

export const bot_API_endpoint =
  "https://sih-hackathon-bots.onrender.com/api/v1";
// export const bot_API_endpoint = "http://localhost:7000/api/v1";
